import { getDvaApp } from 'umi';

import storage from 'conversional-persistent-storage';


const STATE_KEY = "state"
const WHITELIST = ["location"]

export function getGlobalInitialState() {
  const state = storage.getItem(STATE_KEY);
  if (!state) {
    return {}
  }
  const parsedState = JSON.parse(state)
  if (parsedState.serviceRequest) {
    parsedState.serviceRequest.infiniteList = {};
  }
  return parsedState
}

export function resetPersistentReduxStore() {
  storage.removeItem(STATE_KEY);
}

export function resetLocalStore() {
  if (typeof getDvaApp !== 'function') return
  const dva = getDvaApp()
  if (!dva) return
  const resetActions = []
  dva._models.forEach(model => {
    const resetReducers = Object.keys(model.reducers).filter(reducerName => reducerName.split("/")[1] === "reset")
    if (resetReducers.length > 0)
      resetActions.push(...resetReducers)
  })
  resetActions.forEach(action => {
    dva._store.dispatch({type: action})
  })
}
